import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField } from "../../../Components/Forms/renders";
import datumField from "../../../Components/Forms/datepast";
import tijdField from "../../../Components/Forms/time";
import InputLang from "../../../Components/Forms/Languages/input";
import TextfieldLang from "../../../Components/Forms/Languages/textfield";


class LogboekFormWebsite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <Field
            name="naam"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={InputLang}
            label="Naam van de faciliteit"
            languages={["NL", "DU", "FR", "EN"]}
          />
          <Field
            name="beschrijving"
            type="input"
            validate={required({ msg: "Dit item is verplicht" })}
            component={TextfieldLang}
            label="Omschrijving van de faciliteit"
            languages={["NL", "DU", "FR", "EN"]}
          />
          <Field
            name="reserveringen"
            type="number"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderField}
            label="Aantal reserveringen toegestaan (0 is onbeperkt)"
          />
          <Field
            name="personen"
            type="number"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderField}
            label="Aantal personen per tijdsslot"
          />
          <Field name="startdatum" type="input" validate={required({ msg: "Dit item is verplicht" })} component={datumField} label="Startdatum" />
          <Field name="einddatum" type="input" validate={required({ msg: "Dit item is verplicht" })} component={datumField} label="Einddatum" />
          <Field name="starttijd" type="input" validate={required({ msg: "Dit item is verplicht" })} component={tijdField} label="Tijd opening" />
          <Field name="eindtijd" type="input" validate={required({ msg: "Dit item is verplicht" })} component={tijdField} label="Tijd sluiting" />
          <Field
            name="tijdsloten"
            type="number"
            validate={required({ msg: "Dit item is verplicht" })}
            component={renderField}
            label="Tijdsloten per minuut"
          />
          <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Wijzigen" />
        </div>
      </form>
    );
  }
}
LogboekFormWebsite = reduxForm({
  form: "formprofiel", // a unique identifier for this form
})(LogboekFormWebsite);

// You have to connect() to any reducers that you wish to connect to yourself
LogboekFormWebsite = connect(
  (state) => ({
    initialValues: state.faciliteiten.item, // pull initial values from account reducer
  }) // bind account loading action creator
)(LogboekFormWebsite);

export default LogboekFormWebsite;
